__turbopack_context__.v({
  "break": "Confirmation-module-scss-module__rBXa9G__break",
  "close": "Confirmation-module-scss-module__rBXa9G__close",
  "confirmation": "Confirmation-module-scss-module__rBXa9G__confirmation",
  "confirmation-card": "Confirmation-module-scss-module__rBXa9G__confirmation-card",
  "credit-check-header": "Confirmation-module-scss-module__rBXa9G__credit-check-header",
  "image": "Confirmation-module-scss-module__rBXa9G__image",
  "limited-width": "Confirmation-module-scss-module__rBXa9G__limited-width",
  "plenty-actions": "Confirmation-module-scss-module__rBXa9G__plenty-actions",
  "plenty-invest-link": "Confirmation-module-scss-module__rBXa9G__plenty-invest-link",
  "step-list": "Confirmation-module-scss-module__rBXa9G__step-list",
  "text": "Confirmation-module-scss-module__rBXa9G__text",
});
